module.exports = __webpack_public_path__ + "media/images/flags/ak-a3ae5e2b5639b837f25a0b418cd4faa6.png";